const parseData = (param, precision = 0) => {
  if (!param) return '0'

  return parseFloat(param).toLocaleString('en-US', { maximumFractionDigits: precision })
}

export default parseData
